module.exports = __webpack_public_path__ + "img/icons8-waypoint-map.a487ef66.svg";